export default "__VITE_ASSET__BuIYOBqk__"